import { Chip, useMediaQuery } from "@material-ui/core/";
import MaterialTable from "material-table";
import moment from "moment";
import React from "react";
import DataExport from "../../components/molecules/DataExportComponent";
import colorChange from "../../utils/colorChanges";

const TableOnReports = (props) => {
	const { getDataTables, BaseUrl, tableRef, pageSize, state } = props;
	const isSmallScreen = useMediaQuery("(max-width:780px)"); // Adjust as needed
	// const isTablet = useMediaQuery("(max-width:960px)"); // Adjust as needed

	const headers = [
		{ label: "Created", key: "create_time" },
		{ label: "NoTicket", key: "idticket" },
		{ label: "Priority", key: "priority" },
		{ label: "Author", key: "nama_author" },
		{ label: "Service", key: "layanan" },
		{ label: "Category", key: "kategori" },
		{ label: "location", key: "location" },
		{ label: "User", key: "user_assignee" },
		{ label: "Group", key: "group_assignee" },
		{ label: "Close", key: "close_time" },
		{ label: "WorkTime", key: "work_time" },
		{ label: "Deadline", key: "status_deadline" },
		{ label: "Status", key: "status" },
	];

	const columns = [
		{
			title: "No Ticket",
			field: "idticket",
		},
		{
			title: "Priority",
			field: "priority",
			render: (rowData) => (
				<Chip
					clickable
					label={`#${rowData.priority}`}
					size="medium"
					style={{
						backgroundColor: colorChange(rowData.priority).backgroundColor,
						color: colorChange(rowData.priority).color,
						fontWeight: "bold",
					}}
					variant="outlined"
				/>
			),
		},
		{ title: "Subject", field: "title_issue" },
		{ title: "Author", field: "nama_author" },
		{ title: "Service", field: "layanan" },
		{ title: "Category", field: "kategori" },
		{ title: "Location", field: "location" },
		{ title: "Description", field: "description_issue" },
		{ title: "User Assignee", field: "user_assignee" },
		{ title: "Group Assignee", field: "group_assignee" },
		{ title: "StartDate", field: "start_time" },
		{ title: "DueDate", field: "deadline_time" },
		{ title: "Close Time", field: "close_time" },
		{ title: "Work Time", field: "work_time" },
		{
			title: "Status Deadline",
			field: "status_deadline",
			render: (rowData) => (
				<Chip
					clickable
					label={rowData.status_deadline}
					size="medium"
					style={{
						backgroundColor: colorChange(rowData.status_deadline)
							.backgroundColor,
						color: colorChange(rowData.status_deadline).color,
						fontWeight: "bold",
					}}
					variant="outlined"
				/>
			),
		},
		{
			title: "Ticket Status",
			field: "status",
			render: (rowData) => (
				<Chip
					clickable
					label={rowData.status}
					size="medium"
					style={{
						backgroundColor: colorChange(rowData.status).backgroundColor,
						color: colorChange(rowData.status).color,
						fontWeight: "bold",
					}}
					variant="outlined"
				/>
			),
		},
	];

	return (
		<div
			style={{
				backgroundColor: "white",
				// padding: "1rem",
				marginBottom: "1rem",
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
			}}
		>
			<h3 style={{ padding: "10px" }}>Report History</h3>
			<MaterialTable
				style={{ boxShadow: "none" }}
				title=""
				tableRef={tableRef}
				columns={columns}
				data={getDataTables({
					url: `${BaseUrl}`,
					state: state,
					type: "listReport",
				})}
				components={{
					Actions: ({ data }) =>
						!isSmallScreen && (
							<DataExport
								headers={headers}
								datas={data}
								orientation="landscape"
								pageSize="A4"
								fontSize={8}
								filename={`Report History ${moment().format(
									"YYYY-MM-DD HH:mm"
								)}`}
							/>
						),
				}}
				options={{
					selection: !isSmallScreen,
					paginationType: "stepped",
					pageSize: pageSize,
					pageSizeOptions: [5, 10, 15, 25, 50, 75, 100],

					headerStyle: {
						backgroundColor: "#67A3D5",
						color: "#FFF",
					},
					rowStyle: (rowData) => {
						if (rowData.tableData.id % 2) {
							return {
								backgroundColor: "#EEEEEE",
							};
						}
						return {
							backgroundColor: "#fff",
						};
					},
				}}
			/>
		</div>
	);
};

export default TableOnReports;
